<!-- eslint-disable -->
<template lang="pug">
    .drop-box(
        :class="{\
            'drop-box_large': itemsLength > 9,\
        }",
        ref="drop-box"
    )
        .drop-box__shadow.drop-box__shadow_left
            svg-icon.drop-box__arrow-icon(
                name="angle-left",
                :height='customIconSizes.height',
                :width="customIconSizes.width"
            )
        .items(
            v-if="gameMode !== 'inTurn' || gameStarted"
            @wheel='handleScrollOfBox'
            ref="items"
        )
            .items__container(ref="items-container")
                slot
        .drop-box__shadow.drop-box__shadow_right
            svg-icon.drop-box__arrow-icon(
                name="angle-right",
                :height='customIconSizes.height',
                :width="customIconSizes.width"
            )
</template>

<script>
    /*eslint-disable*/
    const ELEMENT_MIN_SIZE_IN_PX = 90

    export default {
        props: {
            gameStarted: Boolean,
            gameMode: String,
            itemsLength: {
                type: Number,
                default: 10
            }
        },
        watch: {
            itemsLength: {
                handler(val) {
                    val === 0
                        ? this.$nextTick(() => this.setOneElementDropDown())
                        : this.$nextTick(() => this.defineDropBoxWidth());
                },
                immediate: true
            },
        },
        computed: {
            customIconSizes () {
                const windowWidth = window.innerWidth;
                if (windowWidth < 576) {
                    return  { height: '19px', width: '12px' };
                } else if (windowWidth < 992) {
                    return  { height: '26px', width: '16px' };
                }
                return  { height: '32px', width: '20px' };
            }
        },
        data () {
            return {
                oneElementSize: null
            }
        },
        methods: {
            handleScrollOfBox (e) {
                e = window.event || e;
                let delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
                this.$refs.items.scrollLeft -= (delta * 65);
                e.preventDefault();
            },
            setOneElementDropDown () {
                this.$refs.items.style['min-width'] = `${this.oneElementSize + 30 * 2}px`
                this.$refs.items.style['min-height'] = `${this.oneElementSize + 15 * 2}px`;
            },
            async defineDropBoxWidth () {
                this.$refs['drop-box'].style.width = '100%';
                const itemsNodes = await this.$refs['items-container'].childNodes;
                this.oneElementSize = Math.max(itemsNodes[0].clientHeight, ELEMENT_MIN_SIZE_IN_PX);
                for (const element of itemsNodes) {
                    element.style.width = this.oneElementSize + 'px';
                    element.style.height = this.oneElementSize + 'px';
                }
                this.$refs['drop-box'].style.width = 'auto';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .drop-box {
        position: relative;
        max-width: 100%;
        width: 100%;
    }

    .drop-box__shadow {
        top: 4px;
        display: flex;
        align-items: center;
        position: absolute;
        z-index: 100;
        height: calc(100% - 4px);
    }

    .drop-box__shadow_right {
        right: 0;
        padding-right: 14px;
        justify-content: flex-end;
        background: linear-gradient(to right, transparent, white);
        border-radius: 0 $border-radius-10 $border-radius-10 0;
        @include media($md) {
            padding-right: 30px;
        }
    }

    .drop-box__shadow_left {
        left: 0;
        padding-left: 14px;
        justify-content: flex-start;
        background: linear-gradient(to left, transparent, white);
        border-radius: $border-radius-10 0 0 $border-radius-10;
        @include media($md) {
            padding-left: 30px;
        }
    }

    .drop-box__arrow-icon {
        color: $hsl-color-blue-56;
    }

    .items {
        background-color: white;
        border-radius: $border-radius-10;
        border: 1px solid $color-grey-300;
        border-left: none;
        border-right: none;
        box-sizing: border-box;
        height: 100%;
        overflow-x: auto;
        white-space: nowrap;
        user-select: none;
        text-align: center;
        transform: rotateX(180deg);
        padding: 10px 0;
        @include media($xlg) {
            padding: 20px 0;
        }
        &::-webkit-scrollbar-track, &::-webkit-scrollbar-track {
            background: #E6E6F8;
        }
        &::-webkit-scrollbar, &::-webkit-scrollbar {
            background-color: #E6E6F8;
            height: 4px;
        }
        &::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb {
            height: 4px;
            background: #C1C1F2;
        }
    }

    .items:not(:first-child) {
        padding-left: 28px;
        @include media($md) {
            padding-left: 60px;
        }
    }

    .items:not(:last-child) {
        padding-right: 28px;
        @include media($md) {
            padding-right: 60px;
        }
    }

    .items__container {
        margin: 0 -10px;
        height: 100%;
        transform: rotateX(180deg);
    }
</style>
